
import {
    ADD_PROSPECT_HOME,
    ADD_PROSPECT_HOME_SUCCESS,
    ADD_PROSPECT_HOME_ERROR,
    UPDATE_PROSPECT_HOME,
    UPDATE_PROSPECT_HOME_SUCCESS,
    UPDATE_PROSPECT_HOME_ERROR,
    DELETE_PROSPECT_HOME,
    DELETE_PROSPECT_HOME_SUCCESS,
    DELETE_PROSPECT_HOME_ERROR,

} from "./actionTypes"
// addLeadHome
export const addProspectHome = payload => {
    return {
        type: ADD_PROSPECT_HOME,
        payload: payload,
    }
}

// addLeadHomeSuccess
export const addProspectHomeSuccess = prospect => {
    return {
        type: ADD_PROSPECT_HOME_SUCCESS,
        payload: prospect,
    }
}

// addLeadHomeError
export const addProspectHomeError = error => {
    return {
        type: ADD_PROSPECT_HOME_ERROR,
        payload: error,
    }
}

// updateLeadHome
export const updateProspectHome = payload => {
    return {
        type: UPDATE_PROSPECT_HOME,
        payload: payload,
    }
}

// updateLeadHomeSuccess
export const updateProspectHomeSuccess = prospect => {
    return {
        type: UPDATE_PROSPECT_HOME_SUCCESS,
        payload: prospect,
    }
}

// updateLeadHomeError
export const updateProspectHomeError = error => {
    return {
        type: UPDATE_PROSPECT_HOME_ERROR,
        payload: error,
    }
}

// deleteLeadHome
export const deleteProspectHome = payload => {
    return {
        type: DELETE_PROSPECT_HOME,
        payload: payload,
    }
}

// deleteLeadHomeSuccess
export const deleteProspectHomeSuccess = prospect => {
    return {
        type: DELETE_PROSPECT_HOME_SUCCESS,
        payload: prospect,
    }
}

// deleteLeadHomeError
export const deleteProspectHomeError = error => {
    return {
        type: DELETE_PROSPECT_HOME_ERROR,
        payload: error,
    }
}

  //Lead Homes//